<template>
  <component :is="stepComponent" v-if="stepComponent && isStepVisible" :step="currentStep" />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useSurveyModal } from '@/features/survey/store'
import type { SurveyStep } from '@/features/survey/types/survey-config'

import WelcomeStep from './WelcomeStep.vue'
import GenderStep from './GenderStep.vue'
import MeasurementStep from './MeasurementStep.vue'
import ChoiceStep from './ChoiceStep.vue'
import ThankYouStep from './ThankYouStep.vue'
import ReviewStep from './ReviewStep.vue'
import CompletionStep from './CompletionStep.vue'
import ResultsStep from './ResultsStep.vue'

const surveyStore = useSurveyModal()
const currentStep = computed(() => surveyStore.currentStep)

const isStepVisible = computed(() => {
  const step = currentStep.value
  if (!step) return false
  
  return surveyStore.shouldStepBeVisible(step)
})

const stepComponent = computed(() => {
  const step = currentStep.value
  if (!step) return null

  switch (step.type) {
    case 'welcome':
      return WelcomeStep
    case 'gender':
      return GenderStep
    case 'measurement':
      return MeasurementStep
    case 'shoe_size':
      return MeasurementStep
    case 'choice':
      return ChoiceStep
    case 'thank_you':
      return ThankYouStep
    case 'review':
      return ReviewStep
    case 'completion':
      return CompletionStep
    case 'results':
      return ResultsStep
    default:
      console.warn(`Unknown step type: ${(step as any).type}`)
      return null
  }
})
</script>

